import { atom } from 'infrastructure/state/jotai.wrapper'

export const lessonMappingTreesAtom = atom<
  { treeId: string; versionId: string; title: string }[]
>([])

export const lessonMappingFlowIds = atom<string[]>([])
